import { KeyboardArrowRight } from '@mui/icons-material';
import { FC } from 'react';
import { PatientProfileHeader } from '../../header/header';
import { usePatientProfileWidget } from '../../hooks/use-patient-profile-widget';
import { useMainMenuConfig } from '../../navigation/use-main-menu-config';
import { Menu, MenuItem, MenuItemIcon } from './main.styles';

export const MainView: FC = () => {
  const { goTo } = usePatientProfileWidget();
  const mainMenuConfig = useMainMenuConfig();

  return (
    <>
      <PatientProfileHeader />
      <Menu>
        {mainMenuConfig.map((item, index) => (
          <MenuItem key={index} onClick={() => goTo(item.path)}>
            {item.title}
            {item.icon ? <MenuItemIcon>{item.icon}</MenuItemIcon> : null}
            <KeyboardArrowRight sx={{ marginLeft: 'auto' }} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
